const updateRecap = (state = {}, action) => {
    const { type = null, datasource, data = {} } = action;
    if (type === 'dataEngine_update_response') {
        if (datasource === 'contentGraph' || datasource === 'content') {
            const { recap } = data;
            return { ...state, ...recap, ...{ isDataLoaded: true } };
        }
    }

    if (type === 'dataEngine_update_error') {

        if (datasource === 'contentGraph' || datasource === 'content') {
            return { ...state, ...{ isDataLoaded: false, error: true } };
        }
    }

    return state;
};

export default updateRecap;
